import api from '..';

export default ({ dictionary, country, departure, partner }) => {
  const timeTo = dictionary === 'TourName' ? 3000 : 5 * 60000
  let url = `/tourclient/api/tour/filter/${dictionary}?`;
  if (country) {
    url += `CountryId=${country?.value || country}&`;
  }
  if (departure) {
    url += `DepartureCityId=${departure?.value || departure}&`;
  }
  if (partner) {
    url += `PartnerId=${partner?.value || partner}&`;
  }
  url += `_=${Date.now()}`;
  return api.get(url, {
    id: `dictionary/${dictionary}/${departure?.value || departure}/${country?.value || country}`,
    time: timeTo,
    formatting: true,
  });
};
